<template>
  <div class="datapeople-administrators" :class="{ 'single-column': !showDemographicSurveyTable }">
    <div class="d-flex flex-column align-items-start justify-content-start">
      <TableTitle
        title="JobNav Recruiter Administrators"
        description="Contact anyone listed below to update JobNav settings and permissions across the platform."
      />
      <AdminTable
        v-if="administrators.length || listLoading"
        class="mt-4"
        :admins="administrators"
        :loading="listLoading"
      />
      <NoAdministratorsBlock
        v-else
        class="mt-4"
      />
    </div>
    <div v-if="showDemographicSurveyTable" class="d-flex flex-column align-items-start justify-content-start">
      <TableTitle
        title="Demographic Survey Report Administrators"
        min-height="46.5px"
      >
        <template #description>
          <p>
            Contact anyone listed below to request access to the
            <a
              href="/app/insights/demographic-survey-report?tab=survey"
              target="_blank"
              rel="noopener noreferrer"
              class="text-decoration-underline"
            >
              Demographic Survey Report
            </a>
            Survey Insights tab.
          </p>
        </template>
      </TableTitle>
      <AdminTable
        v-if="demographicSurveyAdmins.length || listLoading"
        class="mt-4"
        :admins="demographicSurveyAdmins"
        :loading="listLoading"
      />
      <NoDSRAdminBlock
        v-else
        class="mt-4"
      />
    </div>
  </div>
</template>

<script setup>
import TableTitle from '@/components/settings/team/TableTitle.vue';
import NoDSRAdminBlock from '@/components/settings/team/NoDSRAdminBlock.vue';
import AdminTable from '@/components/settings/team/AdminTable.vue';
import { onMounted, computed } from 'vue';
import { useSettingsTeam } from '@/stores/settings/team';
import { storeToRefs } from 'pinia';
import { useAppLoading } from '@/stores/app/loading';
import { useAppAuthData } from '@/stores/app/authData';
import { DEMOGRAPHIC_SURVEY_SHOW } from '@/helpers/constants/demographicSurveyVersions';
import NoAdministratorsBlock from '@/components/settings/team/NoAdministratorsBlock.vue';

const emit = defineEmits(['track-page-load']);

const { listLoading } = storeToRefs(useAppLoading());
const { authData, integrated } = storeToRefs(useAppAuthData());
const { administrators, demographicSurveyAdmins } = storeToRefs(useSettingsTeam());

const { loadAdministrators, loadDemographicSurveyAdmins } = useSettingsTeam();

const showDemographicSurveyTable = computed(() => {
  const { demographicSurveyReportVersion } = authData.value;

  return integrated.value
    && demographicSurveyReportVersion === DEMOGRAPHIC_SURVEY_SHOW;
});

onMounted(() => {
  emit('track-page-load', { page: 'JobNav Recruiter Administrators' });

  return Promise.all([
    loadAdministrators(),
    loadDemographicSurveyAdmins(),
  ]);
});
</script>

<style scoped lang="less">
.datapeople-administrators {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;

  &.single-column {
    grid-template-columns: 1fr;
  }
}
</style>
